import {
  fetchAllCategories,
  createCategory,
  updateCategory,
  deleteCategory,
} from '@api/appFlowConfig';

export const DEFAULT_CATEGORY_MASTER_COLUMN_LIST = [
  { id: 'category_key', name: 'Category Key' },
  { id: 'category_label', name: 'Category Label' },
];

export const DEFAULT_CATEGORY_MASTER_CSV_FIELD_LIST = [
  { id: 'category_key', name: 'Category Key' },
  { id: 'category_label', name: 'Category Label' },
];

const getKeyMappingCategorySingle = (masterData) => {
  return (
    masterData.ops_dashboard_config?.config?.category_master_config
      ?.csv_field_list || DEFAULT_CATEGORY_MASTER_CSV_FIELD_LIST
  );
};

const formItemLayout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};

const viewControl = {
  pageTitle: 'Category Master',
  buckets: ['categoryMaster'],
  globalActions: [],
  addOptions: [
    {
      key: 'add_single',
      title: 'Single',
      action: 'add',
      type: 'single',
    },
  ],
  id: 'id',
  fetchData: fetchAllCategories,
  onSingleAdd: createCategory,
  add: {
    sampleUrl: undefined,
    downloadSampleCsvFromApiCall: false,
    downloadSampleCsv: null,
    title: 'Add Category',
  },
  edit: {
    title: 'Edit Category',
    okText: 'Update',
  },
  warningMsg: 'No category to add',
  successMsg: 'Category added successfully',
  updateMsg: 'Category updated successfully',
  modalHeading: 'Category Master',
  singleUploadMapping: getKeyMappingCategorySingle,
  onSingleUpdate: updateCategory,
  onSingleDelete: (categoryId) => deleteCategory(categoryId),
  deleteMsg: 'Category deleted successfully',
  formItemLayout,
};

const buckets = {
  categoryMaster: {
    name: 'Categories',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
